<template>
  <div>
    <CCheckBox
      v-for="(option, index) in repeatOptions"
      :key="index"
      :label="option.label"
      :value="option.value"
      @change="(e) => (model = e.target.value)"
      :checked="model === option.value"
      type="radio"
      class="custom-radio"
      :custom="true"
    />
  </div>
</template>

<script>
export default {
  name: "RecurrenceRadioGroup",
  props: ["value", "modelValue"],
  emits: ["update:modelValue", "input", "change", "blur"],
  data() {
    return {
      model: "",
      repeatOptions: [
        {
          label: "No repetition",
          value: ""
        },
        {
          label: "Daily(M-F)",
          value: "daily"
        },
        {
          label: "Weekly",
          value: "weekly"
        },
        {
          label: "Monthly",
          value: "monthly"
        }
      ]
    }
  },
  watch: {
    modelValue(value) {
      this.model = value
    },
    model(value) {
      this.$emit("input", value)
      this.$emit("update:modelValue", value)
    }
  }
}
</script>

<style></style>
